import { useAsync } from 'react-use';

import { identityApiRef, useApi } from '@backstage/core-plugin-api';

/**
 * Teams the resource group tag fix is soft-released to. Delete this hook and
 * its use in `ResourceGroupTagFix` to release the fix to everyone.
 */
export const TAG_FIX_SOFT_RELEASE_TEAMS = [
  'SUP0002424',
  'SUP0002450',
  'SUP0001792',
  'SUP0002448',
];

const SOFT_RELEASE_GROUP_REFS = TAG_FIX_SOFT_RELEASE_TEAMS.map(
  team => `group:default/${team.toLowerCase()}`,
);

/**
 * Whether the signed-in user is a member of a soft-release team. Stays `false`
 * until their identity resolves, so nobody sees the fix flash up and vanish.
 */
export const useTagFixSoftRelease = (): boolean => {
  const identityApi = useApi(identityApiRef);

  const { value } = useAsync(async () => {
    const { ownershipEntityRefs = [] } =
      await identityApi.getBackstageIdentity();
    return ownershipEntityRefs.some(ref =>
      SOFT_RELEASE_GROUP_REFS.includes(ref.toLowerCase()),
    );
  }, [identityApi]);

  return value ?? false;
};
